export const SITE_MAX_WIDTH = 1440;
export const COMMON_PADDING = '20px';
export const HEADER_HEIGHT = '134px';
export const FOOTER_HEIGHT = '77px';

export const colors = {
  primary: '#623CE7',
  gray: '#9196A7',
  gray_light: '#F7F8FC',
  white: '#FFFFFF',
  green: '#4CAF50',
  red: '#B71C1C',
};

export const shadows = {
  green: 'rgba(76, 175, 80, 0.56)',
  red: 'rgba(183, 28, 28, 0.56)',
};
